module.exports = __webpack_public_path__ + "media/games-7.4891ef83.mp4";